// customer.reducer.js

export const setCustomerId = (customerId) => {
  // Save to localStorage so it persists on refresh
  if (customerId) {
    localStorage.setItem('maya_customer_id', customerId);
  } else {
    localStorage.removeItem('maya_customer_id');
  }
  
  return {
    type: 'SET_CUSTOMER_ID',
    payload: customerId,
  };
};

// Load initial state from localStorage
const initialState = {
  customerId: localStorage.getItem('maya_customer_id') || null,
};

//create reducer for customer
const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CUSTOMER_ID':
      return { ...state, customerId: action.payload };
    default:
      return state;
  }
};

export default customerReducer;
